import { render, staticRenderFns } from "./IconChannel.vue?vue&type=template&id=21cd3a38&"
import script from "./IconChannel.vue?vue&type=script&lang=js&"
export * from "./IconChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports